import { ApiAnalyticsAggregationDate } from "@/types/analytics/analytics.types.ts";

export interface ApiAnalyticsEmployeesFilter {
  date_from?: Date;
  date_to?: Date;
  aggregation_date_mode?: ApiAnalyticsAggregationDate;
  job_profile_ids?: number[];
  job_role_ids?: number[];

  format?: string;
}

// export interface ApiAnalyticsRecruitingReportRowBase {
//   value: number;
//   value2: number;
// }
//
// /* Stage Flow */
//
// export interface ApiAnalyticsRecruitingStageFlowReportRowItem
//   extends ApiAnalyticsRecruitingReportRowBase {
//   pipeline_stage: ApiPipelineStage;
//   applicants_ids: number[];
// }
//
// export interface ApiAnalyticsRecruitingStageFlowReportRow
//   extends ApiAnalyticsRecruitingReportRowBase {
//   date_report_from: Date;
//   date_report_to: Date;
//   employee?: ApiEmployeeShort;
//   job?: ApiJobShort;
//   stages: ApiAnalyticsRecruitingStageFlowReportRowItem[];
// }
//
// export interface ApiAnalyticsRecruitingStageFlowReport {
//   filter: ApiAnalyticsRecruitingFilter;
//   config: {
//     stages: ApiPipelineStage[];
//   };
//   report: {
//     rows: ApiAnalyticsRecruitingStageFlowReportRow[];
//   };
// }
//
// /* Source Efficiency */
//
// export interface ApiAnalyticsRecruitingSourceEfficiencyReportRowItem
//   extends ApiAnalyticsRecruitingReportRowBase {
//   applicants_ids: number[];
//   source: ApiSource;
// }
//
// export interface ApiAnalyticsRecruitingSourceEfficiencyReportRow {
//   sources: ApiAnalyticsRecruitingSourceEfficiencyReportRowItem[];
//   pipeline_stage: ApiPipelineStage;
// }
//
// export interface ApiAnalyticsRecruitingSourceEfficiencyReport {
//   filter: ApiAnalyticsRecruitingFilter;
//   config: {
//     stages: ApiPipelineStage[];
//     sources: ApiSource[];
//   };
//   report: {
//     rows: ApiAnalyticsRecruitingSourceEfficiencyReportRow[];
//   };
// }
//
// /* Disqualification Reasons */
//
// export interface ApiAnalyticsDisqualificationReasonsReportRowItem
//   extends ApiAnalyticsRecruitingReportRowBase {
//   applicants_ids: number[];
//   reason: ApiCandidateDisqualificationReason;
// }
//
// export interface ApiAnalyticsRecruitingDisqualificationReasonsReportRow {
//   reasons: ApiAnalyticsDisqualificationReasonsReportRowItem[];
//   pipeline_stage: ApiPipelineStage;
// }
//
// export interface ApiAnalyticsRecruitingDisqualificationReasonsReport {
//   filter: ApiAnalyticsRecruitingFilter;
//   config: {
//     stages: ApiPipelineStage[];
//     reasons: ApiCandidateDisqualificationReason[];
//   };
//   report: {
//     rows: ApiAnalyticsRecruitingDisqualificationReasonsReportRow[];
//   };
// }
//
// /* Closing Time */
// export interface ApiAnalyticsRecruitingClosingTimeReportRow
//   extends ApiAnalyticsRecruitingReportRowBase {
//   pipeline_stage: ApiPipelineStage;
//   applicants_ids: number[];
// }
//
// export interface ApiAnalyticsRecruitingClosingTimeReport {
//   filter: ApiAnalyticsRecruitingFilter;
//   config: {
//     stages: ApiPipelineStage[];
//   };
//   report: {
//     hired_candidate_count: number;
//     hired_from_jobs_count: number;
//     average_days_for_closing: number;
//     rows: ApiAnalyticsRecruitingClosingTimeReportRow[];
//   };
// }
//
// export const getAnalyticsAggregationDateOptions = () => {
//   return [
//     {
//       id: ApiAnalyticsAggregationDate.day,
//       title: i18n.t("common:group_period_by_day"),
//     },
//     {
//       id: ApiAnalyticsAggregationDate.week,
//       title: i18n.t("common:group_period_by_week"),
//     },
//     {
//       id: ApiAnalyticsAggregationDate.month,
//       title: i18n.t("common:group_period_by_month"),
//     },
//     {
//       id: ApiAnalyticsAggregationDate.quarter,
//       title: i18n.t("common:group_period_by_quarter"),
//     },
//     {
//       id: ApiAnalyticsAggregationDate.year,
//       title: i18n.t("common:group_period_by_year"),
//     },
//   ] as SelectItem[];
// };

export enum CompensationRollupType {
  gross = "gross",
  net = "net",
  total_cost = "total_cost",
}
